import { z } from "zod";

export const PaymentTermsSchema = z.enum([
  "UNKNOWN",
  "DUE_UPON_RECEIPT",
  "NET_10",
  "NET_15",
  "NET_30",
  "NET_45",
  "NET_60",
]);
